// extracted by mini-css-extract-plugin
export default {"Control":"Control_Control__fCkTA","Header":"Control_Header__P0A2Z"};